module.exports = __webpack_public_path__ + "assets/clear_search-7250b9.svg";